import { CLEAR_CONFIRMATION_MESSAGE, SET_CONFIRMATION_MESSAGE } from '../../constants/actions/confirmation';

const initialState = {
    primaryHeader: null,
    secondaryHeader: null,
    label: null,
    phoneNumber: null,
};

function confirmationReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CONFIRMATION_MESSAGE:
            return {
                ...state,
                ...action.payload,
            };
        case CLEAR_CONFIRMATION_MESSAGE:
            return initialState;
        default:
            return state;
    }
}

export default confirmationReducer;
